module.exports = __webpack_public_path__ + "static/media/preview_marking.9080bac9.svg";